/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const phone_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#phone_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M14.977 22.15c1.079.629 2.252.959 3.508.82 1.69-.184 2.85-1.165 3.994-2.31a1.823 1.823 0 0 0 0-2.551l-3.19-3.188a1.823 1.823 0 0 0-2.551 0 1.822 1.822 0 0 1-2.551 0L9.083 9.816a1.824 1.824 0 0 1 0-2.552c.687-.686.694-1.857 0-2.55L5.894 1.52a1.824 1.824 0 0 0-2.552 0c-1.144 1.144-2.124 2.305-2.31 3.994-.132 1.205.145 2.493.821 3.508A48.842 48.842 0 0 0 14.977 22.15Z"
      />
    </g>
    <defs>
      <clipPath id="phone_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default phone_medium
